import { render, staticRenderFns } from "./NewAppPackageArchitecture.vue?vue&type=template&id=47d9fe1c"
import script from "./NewAppPackageArchitecture.vue?vue&type=script&lang=js"
export * from "./NewAppPackageArchitecture.vue?vue&type=script&lang=js"
import style0 from "./NewAppPackageArchitecture.vue?vue&type=style&index=0&id=47d9fe1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports